export default "__VITE_ASSET__iyKqObQT__"